import './scss/style.scss';

import homeSlider from './js/home-banner';
import playVideoYoutube from './js/play-video-youtube';
import reviewSlider from '../../partials/user-review/js/user-review';
import videoModal from '../../partials/kol-video/js/video-modal';
import packageSlider from './js/package-slider';
// import librarySlider from './js/library-slider';
import PremiumSlider from './js/slider-premium';

$(function () {
  homeSlider();
  playVideoYoutube();
  reviewSlider();
  videoModal();
  packageSlider();
  // librarySlider();
  PremiumSlider();
});
